export default __webpack_public_path__ + "static/media/lining15.222982a6.jpg";